var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-box"},[_c('div',{staticClass:"title"},[_vm._v("批量处理数据中")]),_c('el-progress',{attrs:{"type":"circle","percentage":_vm.percentage}}),_c('div',{staticClass:"tips1"},[_vm._v("正在处理，请稍等...")]),_c('div',{staticClass:"tips2"},[_vm._v("过程中请勿操作此页面，防止处理失败")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }